import script from "./star.vue?vue&type=script&setup=true&lang=js"
export * from "./star.vue?vue&type=script&setup=true&lang=js"

import "./star.vue?vue&type=style&index=0&id=73296a48&lang=scss"

const __exports__ = script;

export default __exports__